import { Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from "../../services/login/login.service";
import { Authenticate } from "../../models/authenticate";
import { Utm } from "../../models/utm";

import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  standalone: true,
  selector: 'app-processlink',
  templateUrl: './processlink.html',
  styleUrls: ['./processlink.css'],
  imports: [CommonModule]
})
export class ProcessLink implements OnInit {

  authenticate!: Authenticate;
  utmtags!: Utm;
  uniqueid?: string;
  pin?: string;
  isLoading = true;
  message = '';
  showDivRouteToHomePage: boolean = false;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    
    const uniqueId = this.route.snapshot.queryParamMap.get('uniqueid');
    const pin = this.route.snapshot.queryParamMap.get('pin');
   

    //console.log('uniqueId:', uniqueId);
    //console.log('pin:', pin);

    if (uniqueId && pin) {
      this.Process(uniqueId, pin);
    }
  }

  Process(uniqueid: any, pin: any) {
    const au = {
      uniqueId: uniqueid,
      pin: pin
    };

    this.loginService.login(au as Authenticate).subscribe({
      next: (result: any) => {
        //console.log('Login result:', result);

        if (result.hasFiled === true) {
          this.isLoading = false;
          this.message = 'You have already completed the filing process.';
          this.showDivRouteToHomePage = true;
          return;
        }


        const utmTags: Utm = {
          utm_source: this.route.snapshot.queryParamMap.get('utm_source'),
          utm_medium: this.route.snapshot.queryParamMap.get('utm_medium'),
          utm_campaign: this.route.snapshot.queryParamMap.get('utm_campaign'),
          utm_content: this.route.snapshot.queryParamMap.get('utm_content')
        };

        this.storage.store('authenticatedUser', result);

        if (Object.values(utmTags).some(value => value)) {
          this.storage.store('utmTags', utmTags);
        }

        this.isLoading = false;
        this.router.navigate(['/file-not-noticed']);
      },
      error: (err) => {
        this.isLoading = false;
        console.error(err);
      }
    });
  }
}
